import React from 'react';
import { 
  Box, 
  List, 
  ListItem, 
  ListItemText, 
  Switch, 
  Typography,
  useMediaQuery
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material';

const RecipeIngredients = ({ 
  recipe, 
  togglePossession 
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  if (!recipe) return null;
  
  const { ingredientsWithPossession, garnishArray, missingCount, id: recipeId } = recipe;

  return (
    <>
      <Box sx={{
        height: { xs: '22px', sm: '26px' },
        visibility: missingCount > 0 ? 'visible' : 'hidden',
        mb: { xs: 0.5, sm: 1 }
      }}>
        <Typography 
          variant="body2" 
          color="error" 
          sx={{ 
            fontSize: '0.9rem',
            fontWeight: 500
          }}
        >
          You are missing {missingCount} {missingCount === 1 ? 'ingredient' : 'ingredients'}
        </Typography>
      </Box>
      
      <List dense={!isMobile}>
        {ingredientsWithPossession.map(ing => (
          <ListItem 
            key={ing.ingredientId} 
            sx={{ py: { xs: 0.25, sm: 0.5 }, px: { xs: 0, sm: 0.5 }, minHeight: { xs: '48px', sm: 'auto' } }}
          >
            <ListItemText
              primary={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Switch
                    checked={ing.possessed}
                    onChange={() => togglePossession(ing.ingredientId)}
                    color="primary"
                    size={isMobile ? "medium" : "small"}
                  />
                  <Link 
                    to={`/ingredient/${encodeURIComponent(ing.ingredientId)}`}
                    state={{ from: { type: 'recipe', id: recipeId } }}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <Typography sx={{ fontSize: '0.95rem' }}>
                      {ing.displayAmount} {ing.name}
                    </Typography>
                  </Link>
                </Box>
              }
            />
          </ListItem>
        ))}
        {garnishArray.map((garnish, index) => (
          <ListItem 
            key={`garnish-${index}`} 
            sx={{ py: { xs: 0.25, sm: 0.5 }, px: { xs: 0, sm: 0.5 }, minHeight: { xs: '48px', sm: 'auto' } }}
          >
            <ListItemText
              primary={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box sx={{ width: { xs: 58, sm: 42 } }} />
                  <Typography sx={{ fontSize: '0.95rem' }}>
                    Garnish: {garnish.name}
                  </Typography>
                </Box>
              }
            />
          </ListItem>
        ))}
      </List>
    </>
  );
};

export default RecipeIngredients; 